import React from 'react';

import blockingTreatmentNamesToString from './helpers/blockingTreatmentNamesToString';

import Notification from '../Notification/Notification';
import { BlockedByBasketBlocker } from '../../../context/hooks/useBasketBlockers/helpers/getBlockedByBasketBlocker/getBlockedByBasketBlocker';

interface Props {
    blockingBasketItems: BlockedByBasketBlocker['data']['blockingBasketItemNames'];
}

/**
 * Notification to the user to say that the treatment the would like is blocked by another item(s) in the
 * basket.
 */
const BlockedByBasketNotification = ({ blockingBasketItems }: Props) => {
    const treatmentsToDisplay = blockingTreatmentNamesToString(blockingBasketItems);

    // TODO: fix types
    // @ts-ignore
    const { setBasketIsOpen } = useBasketContext();

    const openBasket = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setBasketIsOpen((s: boolean) => !s);
    };

    return (
        <Notification>
            You cannot add this treatment to your basket as it already contains {treatmentsToDisplay},
            <button type="button" onClick={openBasket} className="type-link">open your basket</button>
        </Notification>
    );
};

export default BlockedByBasketNotification;
